import * as React from 'react';
import * as stages from './style.module.scss';
import dataStages from "./dataStages.json";
export const Stages = ({ data=dataStages }) => {
  return (
    <section className={stages.stages}>
      <div className="container">
        <h2 className={stages.stages__title}>
          Как проходит обучение:
        </h2>
        <ul className={stages.stages__list}>
          {
            data.map((elem, index) => (
              <li className={stages.stages__item} key={index}>
                <div className={stages.stages__descriptionBlock}>
                  <p className={stages.stages__number}>
                    {elem.number}
                  </p>
                  <p className={stages.stages__elTitle}>
                    {elem.title}
                  </p>
                  <p className={stages.stages__elDescription}>
                    {elem.description}
                  </p>
                </div>
                <div className={stages.stages__imgBlock}>
                  <img src={elem.image} alt=""/>
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    </section>
  );
};
